import UsersService from "@/services/UsersService";

const INITIAL_PAGINATION = {
  pageIndex: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
}

const state = {
  users: [],
  pagination: {...INITIAL_PAGINATION}
}

const mutations = {

  setUsers(state, value) {
    state.users = value;
  },

  setPagination(state, value) {
    state.pagination = value;
  }

}

const getters = {
  users: state => state.users,
  usersPagination: state => state.pagination
}

const actions = {
  createUser(_, payload) {
    return UsersService.createUser(payload);
  },

  deleteUser(_, payload) {
    return UsersService.deleteUser(payload);
  },

  patchUser(_, payload) {
    return UsersService.patchUser(payload);
  },

  async getUsers({commit}, payload) {
    try {
      const {list, pagination} = await UsersService.getUsers(payload);

      commit("setUsers", list);
      commit("setPagination", pagination);
    } catch (error) {
      commit("setUsers", []);
      commit("setPagination", INITIAL_PAGINATION);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
